import {
  DictionaryCustomFieldType,
  ICustomDictionaryType,
  IDictionaryTypes,
} from '~/services/api/dictionaries/types';

const exemptionCategoryDictionary: ICustomDictionaryType = {
  type: IDictionaryTypes.ExemptionCategory,
  name: 'Exemption Category',
  addButtonLabel: 'Add Exemption',
  editButtonLabel: 'Edit Exemption',
  hasDesignedModal: true,
  nameMaxLength: 200,
  customFields: [
    {
      title: 'Renewal Guidance',
      name: 'renewalGuidance',
      type: DictionaryCustomFieldType.TEXTAREA,
      maxLength: 500,
    },
  ],
};

export default exemptionCategoryDictionary;
